import OBase from './OBase';

import * as Geometry from '../geometry';

export default class Bounds extends OBase {
  update () {
    let valTree = this.getFloatInput('Numbers');
    let pOutput = this.getGenericObjectOutput('Domain');

    let outTree = new Geometry.DataTree();

    for (let i = 0; i < valTree.branches.length; i++) {
      let min = Number.POSITIVE_INFINITY;
      let max = Number.NEGATIVE_INFINITY;

      for (let j = 0; j < valTree.branches[i].length; j++) {
        let val = valTree.branches[i][j];

        if (val > max) {
          max = val;
        }

        if (val < min) {
          min = val;
        }
      }

      let interval = new Geometry.Interval(min, max);
      outTree.add(interval, valTree.paths[i]);
    }

    pOutput.value = outTree;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/Bounds.js